import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import { useRealmApp } from '../RealmApp';

export default function useBusinessMutations() {
  const app = useRealmApp();
  return {
    updateBusiness: useUpdateBusiness(app.currentUser.id),
  };
}

const UpdateBusinessMutation = gql`
  mutation UpdateBusiness(
    $businessId: ObjectId!
    $ownerId: String!
    $updates: BusinessUpdateInput!
  ) {
    updatedBusiness: updateOneBusiness(
      query: { _id: $businessId, owner_id: $ownerId }
      set: $updates
    ) {
      _id
      address1
      address2
      city
      country
      image
      color
      language
      name
      phone
      phone2
      webPage
      zip
      currencyCode
      decimalPlaces
      updateDatetime
      idNumber
    }
  }
`;

function useUpdateBusiness(ownerId) {
  const [updateBusinessMutation] = useMutation(UpdateBusinessMutation);
  return async (business, updates) => {
    const {
      data: { updatedBusiness },
    } = await updateBusinessMutation({
      variables: { businessId: business._id, ownerId, updates },
    });
    return updatedBusiness;
  };
}
